<template>
  <Checkout
    v-bind="$attrs"
    :action="route('payments.create', order)"
    :back="route('checkout', { order, step: 'payment' })"
    :order="order"
    :submit="submit"
    action-text="Zahlungspflichtig bestellen"
    back-text="Zurück zur Zahlung"
    step="conclude"
  >
    <template #default="{ openModal }">
      <h1 class="text-lg text-blue-500 mb-1">Bestellung überprüfen</h1>
      <p class="text-sm leading-normal" :class="errorA ? 'text-red-500' : 'text-gray-700'">
        <label>
          <span class="relative pr-1">
            <input
              v-model="form.agreed_to_a"
              style="vertical-align: -15%;"
              class="form-checkbox"
              :class="{ 'border-red-500': errorA }"
              type="checkbox"
            >
          </span>
          Ich erkläre mich mit den
          <a :href="route('pages.terms-and-conditions')" class="text-blue-500" @click="openModal">AGB</a>
          einverstanden und habe die
          <a :href="route('pages.right-of-withdrawal')" class="text-blue-500" @click="openModal">Widerrufsbelehrung</a>
          zur Kenntnis genommen. Ich stimme zu, dass meine E-Mail-Adresse [und mein Name] für die Vertrags&shy;abwicklung und für Informationen zu veranstaltungs&shy;bezogenen Änderungen und Hinweisen verwendet werden darf.
        </label>
      </p>
      <br>
      <p class="text-sm leading-normal" :class="errorB ? 'text-red-500' : 'text-gray-700'">
        <label>
          <span class="relative pr-1">
            <input
              v-model="form.agreed_to_b"
              style="vertical-align: -15%;"
              class="form-checkbox"
              :class="{ 'border-red-500': errorB }"
              type="checkbox"
            >
          </span>
          Die Verarbeitung Ihrer personen&shy;bezogenen Daten erfolgt entsprechend unserer
          <a :href="route('pages.data-protection')" class="text-blue-500" @click="openModal">Datenschutzerklärung</a>.
          Dieser Verwendung können Sie jederzeit widersprechen (z. B. per E-Mail an
          <a href="mailto:shop@dasda-tickets.de" class="text-blue-500">shop@dasda-tickets.de</a>),
          ohne dass dabei andere als die Übermittlungs&shy;kosten nach den Basistarifen entstehen.
        </label>
      </p>

      <div class="border border-gray-300 rounded-md px-4 divide-y mt-6 text-gray-800">
        <Summary label="Kontakt" step="contact" :order="order">
          {{ order.billing_address.email }}
        </Summary>
        <Summary label="Versand" step="shipping" :order="order">
          {{ shipping }}
        </Summary>
        <Summary v-if="order.shipping_method === 'mail'" label="Lieferadresse" step="shipping" :order="order">
          <Address :address="order.shipping_address ?? order.billing_address" />
        </Summary>
        <Summary label="Zahlung" step="payment" :order="order">
          <template v-if="method.image">
            <div class="flex items-center mt-2 mb-1">
              <img
                class="w-10 mr-2"
                :src="method.image.svg"
                :alt="method.description"
                height="24"
                width="32"
              >
              {{ method.description}}
            </div>
          </template>
          <template v-else>
            {{ method.description}}
          </template>
        </Summary>
      </div>

      <div class="border border-gray-300 rounded-md mt-6 text-gray-800">
        <div class="px-4 pb-3 pt-2">
          <Cart :cart="order.cart" class="border-gray-200" />
        </div>
      </div>
    </template>
  </Checkout>
</template>

<script>
import Address from 'Web/Shared/Address.vue';
import Cart from 'Web/Checkout/Cart.vue';
import Checkout from 'Web/Layouts/Checkout.vue';
import Summary from 'Web/Checkout/Summary.vue';
import { computed } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';

export default {
  inheritAttrs: false,
  components: {
    Address,
    Cart,
    Checkout,
    Summary,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    method: {
      type: Object,
      required: true,
    }
  },
  setup(props) {
    const form = useForm('conclude', {
      agreed_to_a: null,
      agreed_to_b: null,
    });

    function submit(event) {
      form.post(event.target.action);
    }

    const shipping = computed(() => ({
      email: 'E-Mail',
      mail: 'Postversand',
    }[props.order.shipping_method]));

    const errorA = computed(() =>
      form.errors.agreed_to_a && !form.agreed_to_a
    );

    const errorB = computed(() =>
      form.errors.agreed_to_b && !form.agreed_to_b
    );

    return {
      errorA,
      errorB,
      shipping,
      form,
      submit,
    }
  }
}
</script>
